export default {"src":"/_next/static/media/circle-play.7583e25d.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};